import React, { useEffect, useState, useRef } from "react";
import loan4 from "../assets/loan4.png";
import loan2 from "../assets/loan5.png";
import loan3 from "../assets/loan3.png";
import loan5 from "../assets/loan2.png";
import loan1 from "../assets/home_3.webp";
import icon from "../assets/home_bg_1.webp";
import bg2 from "../assets/home_bg_2.webp";
import image1 from "../assets/testimonial_1.webp";
import image2 from "../assets/testimonial_2.webp";
import image3 from "../assets/testimonial_3.webp";
import image4 from "../assets/testimonial_4.webp";
import image5 from "../assets/testimonial_5.webp";
import image6 from "../assets/sk.jpeg";
import useLazyImage, {
  LazyImageComponent,
} from "../components/lazyloader/LazyImage";

const Trademark = () => {
  const testimonials = [
    {
      name: "Rahul Singh",
      city: "Delhi",
      text: "The loan process was very smooth and quick. I didn't expect approval to be this fast. Really happy with the service!",
      image: image4,
    },
    {
      name: "Anjali Mehta",
      city: "Mumbai",
      text: "Very professional and transparent. The staff helped me understand every step clearly!",
      image: image2,
    },
    {
      name: "Divya Sinha",
      city: "Bangalore",
      text: "I've taken loans before, but none were as easy and fast as this. Great experience!",
      image: image3,
    },
    {
      name: "Neha Sharma",
      city: "Pune",
      text: "Loved the quick processing! The team was supportive throughout the journey.",
      image: image1,
    },
    {
      name: "Amit Verma",
      city: "Chennai",
      text: "A smooth experience from start to finish. Highly recommend to anyone in need of a loan.",
      image: image5,
    },
    {
      name: "Shivam Kumar",
      city: "Delhi",
      text: "Quick, reliable, and easy to communicate. Thank you for the great service!",
      image: image6,
    },
  ];

  const { ref: iconBgRef, loadedSrc: loadedIconBg } = useLazyImage(icon);
  const { ref: bottomBgRef, loadedSrc: loadedBottomBg } = useLazyImage(bg2);

  const getVisibleCount = (width) => {
    if (width < 768) return 1;
    if (width < 992) return 2;
    return 3;
  };

  const initialVisible =
    typeof window !== "undefined" ? getVisibleCount(window.innerWidth) : 3;

  const [visibleCount, setVisibleCount] = useState(initialVisible);
  const [currentIndex, setCurrentIndex] = useState(initialVisible);

  const extended = [
    ...testimonials.slice(testimonials.length - visibleCount),
    ...testimonials,
    ...testimonials.slice(0, visibleCount),
  ];

  const trackRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const newCount = getVisibleCount(window.innerWidth);

      setVisibleCount((prev) => {
        if (prev !== newCount) {
          setCurrentIndex(newCount);
        }
        return newCount;
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!testimonials.length) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => prev + 1);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length, visibleCount]);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const handleTransitionEnd = () => {
      const totalReal = testimonials.length;
      const startIndex = visibleCount;
      const endIndex = visibleCount + totalReal - 1;

      if (currentIndex > endIndex) {
        track.style.transition = "none";
        setCurrentIndex(startIndex + ((currentIndex - startIndex) % totalReal));
        setTimeout(() => {
          if (track) {
            track.style.transition = "transform 0.6s ease";
          }
        }, 20);
      }
    };

    track.addEventListener("transitionend", handleTransitionEnd);
    return () =>
      track.removeEventListener("transitionend", handleTransitionEnd);
  }, [currentIndex, visibleCount, testimonials.length]);

  const totalReal = testimonials.length;

  const virtualIndex = (currentIndex - visibleCount + totalReal) % totalReal;

  const handleDotClick = (dotIndex) => {
    setCurrentIndex(dotIndex + visibleCount);
  };

  const getTestimonialDotIndices = () => {
    if (totalReal <= 3) {
      return Array.from({ length: totalReal }, (_, i) => i);
    }
    return [
      (virtualIndex - 1 + totalReal) % totalReal,
      virtualIndex,
      (virtualIndex + 1) % totalReal,
    ];
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;

  return (
    <>
      <div
        className="container-fluid p-3 p-md-3"
        style={{ backgroundColor: "#FFEFCA" }}
      >
        <div className="row">
          <div className="col-1 d-none d-lg-block"></div>
          <div className="col-12 col-lg-10">
            <div
              ref={iconBgRef}
              className="text-center mb-0 mb-md-4 mt-2 mt-md-3 py-2 py-md-5 mx-auto"
              style={{
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                width: "100%",
                minHeight: isMobile ? "500px" : "70vh",
                maxWidth: "100%",
                backgroundImage: loadedIconBg ? `url(${loadedIconBg})` : "none",
              }}
            >
              <div
                className="d-flex justify-content-center align-items-center mb-3 flex-wrap"
                style={{
                  gap: "clamp(0.5rem, 2vw, 1rem)",
                  padding: "0 1rem",
                }}
              >
                <div
                  className="d-none d-sm-block"
                  style={{
                    width: "clamp(80px, 9vw, 168px)",
                    height: "clamp(80px, 10vw, 158px)",
                    backgroundImage: `url(${loan4})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />

                <h4
                  style={{
                    fontWeight: "600",
                    color: "#2d2d2d",
                    textAlign: "center",
                    fontSize: "clamp(18px, 4vw, 28px)",
                    maxWidth: "500px",
                    lineHeight: "1.3",
                    marginTop: "20px",
                  }}
                >
                  Trusted by People Like You, for Loans That Truly Care
                </h4>

                <div
                  className="d-none d-sm-block"
                  style={{
                    width: "clamp(80px, 9vw, 158px)",
                    height: "clamp(80px, 10vw, 158px)",
                    backgroundImage: `url(${loan2})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </div>

              {/* CAROUSEL SECTION */}
              <div className="row d-flex justify-content-center mt-4 mt-md-5 px-2 px-md-0">
                <div className="col-12">
                  <div
                    className="position-relative"
                    style={{ overflow: "hidden", paddingBottom: "2.5rem" }}
                  >
                    {/* TRACK */}
                    <div
                      ref={trackRef}
                      style={{
                        display: "flex",
                        transition: "transform 0.6s ease",
                        transform: `translateX(-${
                          (currentIndex * 100) / visibleCount
                        }%)`,
                      }}
                    >
                      {extended.map((t, index) => (
                        <div
                          key={index}
                          style={{
                            flex: `0 0 calc(100% / ${visibleCount})`,
                            padding: "0 0.75rem",
                            boxSizing: "border-box",
                          }}
                        >
                          <div
                            className="card shadow-sm"
                            style={{
                              borderRadius: "12px",
                              padding: "clamp(1rem, 3vw, 1.5rem)",
                              border: "1px solid #f0f0f0",
                              transition:
                                "transform 0.3s ease, box-shadow 0.3s ease",
                              backgroundColor: "#fff",
                              height: "230px",
                              display: "flex",
                              flexDirection: "column",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform =
                                "translateY(-5px)";
                              e.currentTarget.style.boxShadow =
                                "0 8px 16px rgba(0, 0, 0, 0.1)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "";
                            }}
                          >
                            <div className="d-flex flex-column text-start h-100">
                              <div
                                style={{
                                  flex: "1",
                                  overflow: "hidden",
                                }}
                              >
                                <div
                                  style={{
                                    color: "#f6b100",
                                    marginBottom: "10px",
                                    fontSize: "clamp(14px, 2.5vw, 18px)",
                                    letterSpacing: "2px",
                                  }}
                                >
                                  {"★★★★★"}
                                </div>

                                <p
                                  style={{
                                    fontSize: "clamp(14px, 2vw, 15px)",
                                    color: "#444",
                                    lineHeight: "1.6",
                                    marginBottom: "1rem",
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    WebkitLineClamp: "4",
                                    WebkitBoxOrient: "vertical",
                                  }}
                                >
                                  {t.text}
                                </p>
                              </div>

                              <div className="d-flex align-items-center mt-auto">
                                <div
                                  style={{
                                    width: "clamp(50px, 5vw, 60px)",
                                    height: "clamp(50px, 5vw, 60px)",
                                    borderRadius: "50%",
                                    border: "2px solid #ddd",
                                    backgroundColor: "#f8f8f8",
                                    marginRight: "10px",
                                    flexShrink: "0",
                                    overflow: "hidden",
                                  }}
                                >
                                  <LazyImageComponent
                                    src={t.image}
                                    alt={t.name}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>

                                <div>
                                  <strong
                                    style={{
                                      fontSize: "clamp(13px, 2vw, 14px)",
                                      color: "#2d2d2d",
                                    }}
                                  >
                                    {t.name}
                                  </strong>

                                  <p
                                    style={{
                                      fontSize: "clamp(11px, 1.8vw, 12px)",
                                      color: "#666",
                                      margin: 0,
                                    }}
                                  >
                                    {t.city}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* DOTS */}
                    <div
                      className="d-flex justify-content-center"
                      style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        bottom: "5px",
                      }}
                    >
                      {getTestimonialDotIndices().map((pageIndex) => (
                        <button
                          key={pageIndex}
                          onClick={() => handleDotClick(pageIndex)}
                          className={`dot-indicator ${
                            pageIndex === virtualIndex ? "active" : ""
                          }`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-1 d-none d-lg-block"></div>
        </div>
      </div>

      {/* BOTTOM SECTION */}
      <div
        ref={bottomBgRef}
        style={{
          backgroundImage: loadedBottomBg ? `url(${loadedBottomBg})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "top center",
          backgroundRepeat: "no-repeat",
          minHeight: isMobile ? "450px" : "clamp(500px, 70vh, 80vh)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          marginTop: "clamp(-160px, -15vw, -165px)",
          zIndex: 2,
          overflow: "hidden",
        }}
      >
        <div className="col-1 d-none d-lg-block"></div>
        <div className="col-10">
          <div
            style={{
              maxWidth: "100%",
            }}
          >
            <div className="row align-items-center justify-content-center text-center text-md-start g-4 mt-4">
              {/* Left Section */}
              <div
                className="col-12 col-md-6 mb-4 mb-md-0 mt-5 pt-5"
                style={{ zIndex: 3 }}
              >
                <h3
                  style={{
                    fontWeight: 600,
                    marginBottom: "clamp(1.5rem, 3vw, 3rem)",
                    color: "#fff",
                    fontSize: "clamp(18px, 4vw, 26px)",
                    lineHeight: "1.4",
                    wordWrap: "break-word",
                  }}
                >
                  To know more Enquire Now
                  <br /> or Visit your nearest Shubh Paisa Branch
                </h3>

                <h5
                  style={{
                    fontWeight: 500,
                    marginBottom: "clamp(1rem, 2vw, 2rem)",
                    color: "#fff",
                    fontSize: "clamp(15px, 3vw, 20px)",
                    wordWrap: "break-word",
                  }}
                >
                  Gold Loan Disbursement Options
                </h5>

                <div className="row mt-3 mt-md-4 justify-content-center justify-content-md-start g-3">
                  <div className="col-6 col-sm-5 col-md-4">
                    <LazyImageComponent
                      src={loan3}
                      alt="Instant Cash"
                      style={{
                        width: "clamp(100px, 15vw, 110px)",
                        maxWidth: "100%",
                        height: "auto",
                      }}
                    />
                    <p
                      className="mt-2 mt-md-3"
                      style={{
                        color: "#fff",
                        fontSize: "clamp(14px, 2.2vw, 15px)",
                        fontWeight: "500",
                        wordWrap: "break-word",
                      }}
                    >
                      Instant Cash
                    </p>
                  </div>
                  <div className="col-6 col-sm-5 col-md-4">
                    <LazyImageComponent
                      src={loan5}
                      alt="Direct Online Credit"
                      style={{
                        width: "clamp(100px, 15vw, 110px)",
                        maxWidth: "100%",
                        height: "auto",
                      }}
                    />
                    <p
                      className="mt-2 mt-md-3"
                      style={{
                        color: "#fff",
                        fontSize: "clamp(14px, 2.2vw, 15px)",
                        fontWeight: "500",
                        wordWrap: "break-word",
                      }}
                    >
                      Direct Online Credit
                    </p>
                  </div>
                </div>
              </div>

              {/* Right Image */}
              <div
                className="col-12 col-md-6 position-relative"
                style={{
                  minHeight: isMobile ? "60px" : "clamp(250px, 60vh, 550px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Desktop Image */}
                <div
                  className="d-none d-md-block"
                  style={{
                    position: "absolute",
                    bottom: "clamp(-30px, -5vw, 0px)",
                    right: "clamp(20px, 8vw, 100px)",
                    width: "clamp(250px, 32vw, 420px)",
                    maxWidth: "100%",
                  }}
                >
                  <LazyImageComponent
                    src={loan1}
                    alt="Gold Loan Repayment Options"
                    className="img-fluid"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "20px",
                    }}
                  />
                </div>

                {/* Mobile Image */}
                <div
                  className="d-md-none"
                  style={{
                    position: "relative",
                    width: "100%",
                    maxWidth: "320px",
                    margin: "0 auto",
                    // marginTop: "14rem",
                  }}
                >
                  <LazyImageComponent
                    src={loan1}
                    alt="Gold Loan Repayment Options"
                    className="img-fluid"
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "15px",
                      display: "block",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-1 d-none d-lg-block"></div>
      </div>
    </>
  );
};

export default Trademark;
